import React, { useState } from "react";
import images from "../../../images";

const ProfileAccordion = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="w-full border-b border-[#E9E6E4] border-solid flex flex-col gap-2">
      <div
        onClick={toggleAccordion}
        className="flex items-center justify-between min-h-[54px] py-4 w-full text-sm font-medium tracking-tight text-[#333333] cursor-pointer"
      >
        <div className="text-lg xs:text-xl text-[#333] font-medium flex-1 pr-4">
          {typeof title === "string" ? <span>{title}</span> : title}
        </div>
        <img
          src={images.ChevronDownIcon2x}
          alt=""
          className={`w-[14px] h-[7px] transition-transform duration-300 flex-shrink-0 ${
            isOpen ? "-rotate-180" : "rotate-0"
          }`}
        />
      </div>

      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="pb-4 text-sm text-[#666666] leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ProfileAccordion;
